import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import authTypes from 'reduxConfig/auth.types';
import STEPS from 'constants/steps';
import { setError } from 'reduxConfig/auth.creators';
import { AddTwoFactorAuthSMS } from 'components/app/AddTwoFactorAuthSMS/AddTwoFactorAuthSMS';
import { useTranslation } from 'react-i18next';

const microapps = window.MICROFRONTENDS_CONFIG;

export const AddTwoFactorAuthSMSRoute = ({ dispatch, loading, step, isMobile }) => {
  const { t } = useTranslation();
  const [requiresRecentLogin, setRequiresRecentLogin] = useState(false);
  if (step !== STEPS.addPhoneNumber || requiresRecentLogin)
    return <Redirect to={microapps.routes.login.path} />;
  return (
    <div>
      <nbx-heading tag="h3">{t('auth_2fa_sms_setup')}</nbx-heading>
      <AddTwoFactorAuthSMS
        onClose={() => dispatch({ type: authTypes.FIREBASE_ADD_PHONE_NUMBER_SUCCESS })}
        onSkip={() => dispatch({ type: authTypes.FIREBASE_ADD_PHONE_NUMBER_SKIPPED })}
        onError={e => dispatch(setError(e))}
        isMobile={isMobile}
        loading={loading}
        onRequiresRecentLogin={() => {
          dispatch({
            type: authTypes.FIREBASE_ADD_PHONE_NUMBER_ERROR,
            error: 'auth-signup/requires-recent-login'
          });
          setRequiresRecentLogin(true);
        }}
      />
    </div>
  );
};
